import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updatePacienteRadiologia } from "../services/radiologia.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const usePacienteRadiologiaEditar = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const updateRadiologiaMutation = useMutation({
        mutationFn: updatePacienteRadiologia,
        onSuccess: (radiologia, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['paciente/radiologia', id] });
            variables.success();
            dispatch(successNotification('Radiología editada'));
        },
        onError: (error, variables, context) => {
            // console.log(error);
            dispatch(dangerNotification(error.message));
        },
    });

    return {
        updateRadiologiaMutation,
    }
}